module.exports = __webpack_public_path__ + "static/media/CELR-BNB.ce40a46c.svg";